import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import uuid from 'uuid';
import styles from './uploadInteraction.scss';

class RemoveFileModal extends React.Component {
    static propTypes = {
        closeConfirmation: PropTypes.func.isRequired,
        isOpen: PropTypes.bool,
        removalHandler: PropTypes.func.isRequired,
        services: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.focusableId = `RemoveFileModal-H3-${uuid.v4()}`;
    }

    focus = () => {
        const elementToFocus = document.getElementById(this.focusableId);
        if (elementToFocus) {
            elementToFocus.focus();
        }
    };

    render() {
        const { t } = this.props.services.translationService;

        return (
            <Modal
                className={styles.modalContent}
                contentLabel={t('interactions.upload.removeFileModalHeader')}
                isOpen={this.props.isOpen}
                onAfterOpen={this.focus}
                overlayClassName={styles.modalOverlay}
            >
                <div className={styles.modalTextPane}>
                    <h3 id={this.focusableId}>
                        {t('interactions.upload.removeFileModalHeader')}
                    </h3>
                    <span>{t('interactions.upload.removeFileModal.areYouSure')}</span>
                    <span>{t('interactions.upload.removeFileModal.youCanAddAnotherFileLater')}</span>
                </div>
                <div className={styles.modalButtonPane}>
                    <button className={styles.neutralButton} onClick={this.props.closeConfirmation}>
                        {t('interactions.upload.btnCancel')}
                    </button>
                    <button className={styles.button} onClick={this.props.removalHandler}>
                        {t('interactions.upload.btnConfirmRemoveUploadedFile')}
                    </button>
                </div>
            </Modal>
        );
    }
}

export default RemoveFileModal;
